import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"bv-card__subsection\" ...attributes>\n  {{yield}}\n</div>")